/* PDP share: copy-link + native share. Copies the product URL, plus ?variant=ID only when the page URL has one. */
(function () {
  'use strict';
  var TIMEOUT = 1500;

  function targetUrl(root) {
    var url = root.getAttribute('data-share-url') || location.href.split('#')[0].split('?')[0];
    var v = null;
    try { v = new URLSearchParams(location.search).get('variant'); } catch (e) {}
    return v ? url + '?variant=' + encodeURIComponent(v) : url;
  }

  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, text.length);
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
    return ok ? Promise.resolve() : Promise.reject(new Error('copy failed'));
  }

  function copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () { return legacyCopy(text); });
    }
    return legacyCopy(text);
  }

  function init(root) {
    if (root.__shareInit) return;
    root.__shareInit = true;
    var btn = root.querySelector('[data-share-copy]');
    var live = root.querySelector('[data-share-live]');
    var native = root.querySelector('[data-share-native]');
    var timer;

    if (btn) {
      btn.addEventListener('click', function () {
        copy(targetUrl(root)).then(function () {
          btn.classList.add('is-copied');
          if (live) live.textContent = '';
          setTimeout(function () { if (live) live.textContent = btn.getAttribute('data-msg-ok'); }, 30);
          clearTimeout(timer);
          timer = setTimeout(function () {
            btn.classList.remove('is-copied');
            if (live) live.textContent = '';
          }, TIMEOUT);
        }).catch(function () {
          if (live) live.textContent = btn.getAttribute('data-msg-fail');
        });
      });
    }

    var mobile = window.matchMedia && window.matchMedia('(hover:none) and (pointer:coarse)').matches;
    if (native && mobile && navigator.share) {
      native.hidden = false;
      native.addEventListener('click', function () {
        navigator.share({ title: root.getAttribute('data-share-title') || document.title, url: targetUrl(root) }).catch(function () {});
      });
    }
  }

  function boot() {
    var roots = document.querySelectorAll('.pdp-share');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
